import { TypedActionWithPayload } from '@/types/redux';

export const RESET_ADD_SEARCH_ALERT = 'la/ui/addSearchAlert/RESET';
export type RESET_ADD_SEARCH_ALERT_ACTION = TypedActionWithPayload<typeof RESET_ADD_SEARCH_ALERT>;

export const CLEAR_PROMOTED_SEARCH_RESULTS = 'CLEAR_PROMOTED_SEARCH_RESULTS';
export const LOAD_PROMOTED_SEARCH_RESULTS_FAIL = 'LOAD_PROMOTED_SEARCH_RESULTS_FAIL';
export const LOAD_PROMOTED_SEARCH_RESULTS_REQUEST = 'LOAD_PROMOTED_SEARCH_RESULTS_REQUEST';
export const LOAD_PROMOTED_SEARCH_RESULTS_SUCCESS = 'LOAD_PROMOTED_SEARCH_RESULTS_SUCCESS';

export const LOAD_SEARCH_RESULTS_FAIL = 'la/domain/searchResults/LOAD_FAIL';
export type LOAD_SEARCH_RESULTS_FAIL_ACTION = TypedActionWithPayload<typeof LOAD_SEARCH_RESULTS_FAIL, string>;

export const LOAD_SEARCH_RESULTS_REQUEST = 'la/domain/searchResults/LOAD_REQUEST';
export type LOAD_SEARCH_RESULTS_REQUEST_ACTION = TypedActionWithPayload<typeof LOAD_SEARCH_RESULTS_REQUEST>;

export const LOAD_SEARCH_RESULTS_SUCCESS = 'la/domain/searchResults/LOAD_SUCCESS';
export type LOAD_SEARCH_RESULTS_SUCCESS_ACTION = TypedActionWithPayload<
    typeof LOAD_SEARCH_RESULTS_SUCCESS,
    {
        queryId: string;
        usedIndex: string;
    }
>;

export const SET_USE_GEO_LOCATION = 'la/domain/searchResults/SET_USE_GEO_LOCATION';

export const LOAD_MORE_SEARCH_RESULTS_FAIL = 'la/domain/searchResults/LOAD_MORE_FAIL';
export const LOAD_MORE_SEARCH_RESULTS_REQUEST = 'la/domain/searchResults/LOAD_MORE_REQUEST';
export const LOAD_MORE_SEARCH_RESULTS_SUCCESS = 'la/domain/searchResults/LOAD_MORE_SUCCESS';

export const DEFAULT_ARCHIVE_STATUSES = ['sold', 'passed', 'done'];
export const DEFAULT_LIVE_STATUSES = ['upcoming', 'live', 'online'];
export const DEFAULT_SORT_ORDER = '-relevance';

export const SEARCH_SUGGESTIONS_FAIL = 'la/ui/searchSuggestions/FAIL';
export const SEARCH_SUGGESTIONS_REQUEST = 'la/ui/searchSuggestions/REQUEST';
export const SEARCH_SUGGESTIONS_SUCCESS = 'la/ui/searchSuggestions/SUCCESS';
